const Users = require("../components/Users");
const { connect } = require("react-redux");
const { deleteUser, fetchUsers } = require("actions/users");

module.exports = connect(
    state => ({
        isFetching: state.users.isFetching,
        items: state.users.items,
        hasFetchedAll: state.users.hasFetchedAll,
        currentUser: state.auth.credentials.user
    }),
    { deleteUser, fetchUsers }
)(Users);



// WEBPACK FOOTER //
// ./src/routes/admin-users/containers/Users.js